import { EventsBySportIdRequest } from "sb-bff-integration";
import { ActiveRequestsType } from "../../typings";
import { EntityType } from "sbtech-sports-data-api-contracts";
export var isEntityFromType = function (entity, requestType, events) {
    var entityType = getEntityType(entity, events);
    return entityType === getTypeByRequest(requestType);
};
var getEntityType = function (entity, events) {
    if (entity.entityType === EntityType.Event || entity.entityType === EntityType[EntityType.Event]) {
        return entity.type;
    }
    if (entity.entityType === EntityType.Market || entity.entityType === EntityType[EntityType.Market]) {
        var isOutrightMarket = events.find(function (e) { return e.id === entity.id; }) !== undefined;
        return isOutrightMarket
            ? EventsBySportIdRequest.EventTypesEnum.Outright
            : EventsBySportIdRequest.EventTypesEnum.Fixture;
    }
    return "";
};
var getTypeByRequest = function (requestType) {
    return requestType === ActiveRequestsType.outrights
        ? EventsBySportIdRequest.EventTypesEnum.Outright
        : EventsBySportIdRequest.EventTypesEnum.Fixture;
};
//# sourceMappingURL=isEntityFromType.js.map